/**
 * Module names are centralized here since modules are loaded dynamically
 * and we need a consistent way to refer to them.
 * A module name should match the folder name where the module is located.
 */
enum ModuleNames {
    Oacis = "Oacis",
    Cnesst = "Cnesst",
    Olis = "Olis",
    OntarioMdHealthReportManager = "OntarioMdHealthReportManager",
    DigitalHealthDrugRepository = "DigitalHealthDrugRepository",
    InstantMessaging = "InstantMessaging"
}

export { ModuleNames };
